module.exports = __webpack_public_path__ + "img/keyboard_alice.d03ba371.png";